module.exports = __webpack_public_path__ + "img/playlist.4deeecdf.svg";